import styled from "styled-components";

export const AddParentButton = styled.button`
    padding: 0.8rem;
    font-size: 14px;
    background: rgba(172, 52, 33, 1);
    border: none;
    color: white;
    border-radius: 999em;
    cursor: pointer;

    &:hover {
        background: rgba(172, 52, 33, 0.8);
    }
`;